import { actionCreatorFactory } from 'typescript-fsa'
import { Device } from '../../types'

const actionCreator = actionCreatorFactory()

export const receiveDevice = actionCreator<Device>('receiveDevice')
export const updateDevice = actionCreator<Partial<Device> & { id: string }>(
  'updateDevice',
)
